import PreciseDecimal from 'util/precise-decimal/PreciseDecimal';
import {countSigFigs} from 'util/precise-decimal/SignificantFigures';

export const MONOMER_MW_MAX_SIG_FIGS = 15;

/** Returns true when a raw molecular-weight input string carries more than the supported number of
 * significant figures. Operates on the raw string (before parsing to a number) so scientific notation is
 * counted precisely rather than by string length.
 *
 * Returns false for values that cannot be parsed as a decimal; those are caught by other validation.
 */
export function mwExceedsMaxSigFigs(rawValue: string): boolean {
  const preciseDecimal = PreciseDecimal.ofOrUndefined(rawValue);
  if (preciseDecimal == null) {
    return false;
  }
  return countSigFigs(preciseDecimal) > MONOMER_MW_MAX_SIG_FIGS;
}
